'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgTemplateDetail', sgTemplateDetail);

  sgTemplateDetail.$inject = ['$scope', 'template', 'elements', 'modules', 'PvETemplateAPI', 'BuildingTemplateAPI',
    'errorMessageService', '$state', 'areaTemplates', 'Labels', 'constants', 'EditorConfig', 'SgElementDialogService',
    'ModuleSubmoduleElements', 'LibElement', 'Module'];

  function sgTemplateDetail ($scope, template, elements, modules, PvETemplateAPI, BuildingTemplateAPI,
    errorMessageService, $state, areaTemplates, Labels, constants, EditorConfig, SgElementDialogService,
    ModuleSubmoduleElements, LibElement, Module) {

    // MODEL

    $scope.elements = elements;
    $scope.constants = constants;
    $scope.LABELS = Labels;

    const updateProject = () => {
      $scope.modules = modules;

      if (template.hasOwnProperty('areaTemplates')) {
        BuildingTemplateAPI.get({ id: template._id }).$promise.then((resp) => {
          $scope.template = resp;
          initTreeData();
        });
      } else {
        PvETemplateAPI.get({ id: template._id }).$promise.then((resp) => {
          $scope.template = resp;
          initTreeData();
        });
      }
    };

    updateProject();

    // prepare the elements with module & submodule names
    function initTreeData() {
      $scope.nodes = [];

      for (const module of modules) {
        // only show the active modules
        if (module.active) {
          for (const submodule of module.submodules) {
            // only show the active submodules with elements
            if (submodule.active && submodule.elementIds) {
              // the right order of elements is defined in the submodule.elementIds array
              for (const elementId of submodule.elementIds) {
                // match the element id of the submodule.elementIds array and the element._id of
                // the elements in the collection
                const node = $scope.elements
                  .find(element => (element._id.toString() === elementId && element.active));
                if (node) {
                  node.moduleName = module.name;
                  node.submoduleName = submodule.name;
                  node.selected = $scope.template.elements.includes(node._id);
                  $scope.nodes.push(node);
                }
              }
            }
          }
        }
      }
    }

    /**
     * Handles the order being changed in the treeview and saves it to api
     * @param elements
     */
    $scope.handleChange = function(elements) {
      $scope.saveElements(elements);
    };

    /**
     * Handles click a node
     * @param node
     */
    $scope.handleClick = function(node) {
      if (!node.children) {
        $scope.hightlightSelectedElement(node._id);
        $scope.type = 'view';
        $scope.selectedTab = 1;
      }
    };

    $scope.clonedTemplateName = '' + template.name;
    let lowerCaseTemplateType = '';

    switch ($state.params.templateType) {
      case 'buildingTemplate': {
        lowerCaseTemplateType = 'buildingtemplate';
        $scope.humanReadableType = 'Gebouw template';
        $scope.humanReadableSingular = 'gebouw';
        $scope.apiToUse = BuildingTemplateAPI;
        break;
      }
      case 'pveTemplate':
        lowerCaseTemplateType = 'pvetemplate';
        $scope.humanReadableType = 'PvE-template';
        $scope.humanReadableSingular = 'PvE';
        $scope.apiToUse = PvETemplateAPI;
        break;
    }

    $scope.editor = {
      editing: false
    };

    function setAreaTemplates (providedTemplate = template) {
      const buildAreaTempls = providedTemplate.areaTemplates;
      $scope.selectedAreaTemplates = [];
      $scope.availableAreaTemplates = [];

      if (buildAreaTempls) {
        areaTemplates.forEach((area) => {
          if (buildAreaTempls.indexOf(area._id) > -1) {
            area.type = 'selected';
            $scope.selectedAreaTemplates.push(area);
          } else {
            area.type = 'available';
            $scope.availableAreaTemplates.push(area);
          }
        });
      }
    }

    setAreaTemplates();

    // USER ACTIONS
    $scope.addAreaTemplate = (obj) => {
      const areaToEdit = $scope.availableAreaTemplates.find((area) => area._id === obj.item._id);
      if (!areaToEdit) {
        return false;
      }

      if (!$scope.template.areaTemplates) {
        $scope.template.areaTemplates = [obj.item._id];
      } else {
        $scope.template.areaTemplates.push(obj.item._id);
      }

      obj.item.type = 'selected';
      $scope.saveTemplate();
      return obj.item;
    };

    $scope.removeAreaTemplate = (obj) => {
      const areaToEdit = $scope.selectedAreaTemplates.find((area) => area._id === obj.item._id);
      if (!areaToEdit) {
        return false;
      }

      $scope.template.areaTemplates = $scope.template.areaTemplates.filter((id) => id !== obj.item._id);
      obj.item.type = 'available';
      $scope.saveTemplate();
      return obj.item;
    };

    $scope.lists = [
      {
        label: $scope.LABELS.getPlural('linkedareatemplate'),
        items: $scope.selectedAreaTemplates,
        drop: $scope.addAreaTemplate,
        allowedTypes: ['available'],
      }, {
        label: $scope.LABELS.getPlural('availableareatemplate'),
        items: $scope.availableAreaTemplates,
        drop: $scope.removeAreaTemplate,
        allowedTypes: ['selected']
      },
    ];

    const getAllElements = () => LibElement.getAll({ projectLevel: $state.params.projectLevel });

    const updateElement = (id: string, node: any) => {
      // based on the actual updated element Id, we need to update the element scope
      for (const idx in $scope.fetchedElements) {
        if ($scope.fetchedElements[idx]._id === id) {
          $scope.element = Object.assign({}, $scope.fetchedElements[idx]);
        }
      }

      // Update the element in the scope.elements
      for (const idx in $scope.elements) {
        if (id === $scope.elements[idx]._id) {
          $scope.elements[idx] = Object.assign({}, $scope.element);
        }
      }

      if (node.type === 'element') {
        $scope.$emit('selectElement', $scope.element._id);
      }
    };

    /**
     * updateNode is an object containg 3 different methods
     *
     * Each method is based on the checked, checkbox.
     * Module: Whenever the module checkbox has been checked.
     * Submodule: Whenever the submodule checkbox has been checked.
     * Element: Whenever the element checkbox has been checked.
     */

    const updateNode = {
      module: (node) => {
        for (const idx in node.children) {
          if (node.children[idx].hasOwnProperty('children')) {
            for (const subIdx in node.children[idx].children) {
              if (node.children[idx].children[subIdx]) {
                updateElement(node.children[idx].children[subIdx]._id, node);
              }
            }
          }
        }
      },
      submodule: (node) => {
        if (node.hasOwnProperty('children')) {
          for (const idx in node.children) {
            if (node.children[idx]) {
              updateElement(node.children[idx]._id, node);
            }
          }
        }
      },
      element: (node) => {
        const { _id: nodeId } = node;
        updateElement(nodeId, node);
      },
    };


    // callback that saves the treeview elements
    $scope.saveElements = function (treeviewElements) {
      const saveObj = {};
      saveObj[lowerCaseTemplateType] = {
        elements: treeviewElements
      };

      const _updatedNodes = Object.assign({}, treeviewElements[0]);

      // saveObj doens't need the first index, as this is used as a referal
      saveObj[lowerCaseTemplateType].elements.splice(0, 1);

      return $scope.apiToUse.update({
        id: $scope.template._id
      }, saveObj).$promise.then(response => {
        /**
         * After an element has been updated, we should fetch the most recent element data from our db
         */
        getAllElements().$promise.then(rsp => {
          $scope.fetchedElements = rsp;

          // Based on the response we still need to do some small magic
          _updatedNodes['response'] = Object.assign({}, response);
          updateNode[_updatedNodes.type](_updatedNodes);
        });
      });
    };


    // This controller listens to events that are fired when an element is selected in the sgElementsDragAndDropCtrl
    // which is part of the sgElementsTreeview
    $scope.$on('selectElement', function (event, elementId) {
      $scope.hightlightSelectedElement(elementId);
      $scope.type = 'view';
      $scope.selectedTab = 1;
      event.stopPropagation();
    });

    $scope.hightlightSelectedElement = function (elementId) {
      $scope.elements.map((el) => el.treeviewSelected = false);
      $scope.element = $scope.elements.find((elem) => elem._id === elementId);
      $scope.element.treeviewSelected = true;
    };

    $scope.toggleEdit = function () {
      $scope.editor.editing = !$scope.editor.editing;
    };

    $scope.saveTemplate = function () {
      const dataObj = {};
      dataObj[lowerCaseTemplateType] = $scope.template;
      dataObj[lowerCaseTemplateType].id = dataObj[lowerCaseTemplateType]._id;
      delete dataObj[lowerCaseTemplateType]._id;

      $scope.apiToUse.update({
        id: dataObj[lowerCaseTemplateType].id
      }, dataObj).$promise
        .then(function (res) {
          errorMessageService.showSuccess($scope.LABELS.getLabel('templateedited'));
          $scope.template = res;
          $scope.clonedTemplateName = angular.copy(res.name);
          $scope.editor.editing = false;
        });
    };

    $scope.disabledFields = ['name', 'label', 'value', 'hasInputInstruction', 'inputInstruction'];

    $scope.elementHiddenFields = ['projectLevel', 'moduleId', 'constructionId', 'submoduleId', 'knowledgeLevel',
      'requirementType', 'requirementStrictness', 'inputType', 'unit', 'hasMultipleQualityLevels',
      'logAndComments', 'comment', 'appliesTofases', 'pveTemmplates'];

    $scope.editorOptions = EditorConfig({
      contentLanguage: 'nl',
      inline: true,
      readonly: true,
    });

    $scope.templateInfoEditOptions = EditorConfig({
      contentLanguage: 'nl', // FIXME figure out a way to determine content language
      inline: false,
      readonly: false,
    });

    $scope.openLibElementDialog = function (ev, action, selectedElement) {
      SgElementDialogService.open(ev, action, selectedElement, modules)
       .then((res) => {
          const updatedElement = res.filter(el => el._id === selectedElement._id);
          const updatedElm = Object.assign({}, updatedElement[0]);
          // $scope.elements = res.filter(el => el.projectLevel === $state.params.projectLevel);

          const _updatedNodes = {
            _id: $scope.element._id,
            type: 'element',
            template: $scope.template
          };

          updateProject();

          getAllElements().$promise.then(rsp => {
            $scope.fetchedElements = rsp;
            _updatedNodes['response'] = updatedElm;

            // Based on the response we still need to do some small magic
            updateNode[_updatedNodes.type](_updatedNodes);

            // initTreeData();
            updateProject();
          });


       })
        .catch(() => {
          // cancel was clicked, no need to do anything
        });
    };
  }
})();
